// extracted by mini-css-extract-plugin
export default {"loadingContainer":"AppRoute_loadingContainer__7+6fU"};